export default "__VITE_ASSET__C6Eh_$y$__"